<template>
  <!--begin::Card-->
  <div class="card">
    <!--begin::Card body-->
    <div class="card-body">
    <nav class="navbar navbar-light" style="background-color: #e3f2fd;">
        <div class="container-fluid">
          <a class="navbar-brand"> {{nameNavbar}}</a>
          <button 
            class="navbar-toggler" 
            type="button" 
            data-bs-toggle="collapse" 
            data-bs-target="#navbarSupportedContent" 
            aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
          </button>
          <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav me-auto mb-2 mb-lg-0">
              <!-- <li class="nav-item">
                <a class="nav-link active" aria-current="page" >Añadir Docentes</a>
              </li> -->
              <!-- Personas de Contacto Privados de Libertad -->
              <li class="nav-item dropdown cursor_pointer">
                <a class="nav-link dropdown-toggle" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                  Personas de Contacto Privados de Libertad
                </a>
                <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                  <li><a class="dropdown-item" @click="addPplContact">Búsqueda de Contactos de Privados de Libertad</a></li>
                  <!-- <li><hr class="dropdown-divider"></li>
                  <li><a class="dropdown-item" href="#">Something else here</a></li> -->
                </ul>
              </li>
              <!-- <li><hr class="dropdown-divider"></li> -->
              <!--  Situación Laboral -->
              <li class="nav-item dropdown cursor_pointer">
                <a 
                  class="nav-link dropdown-toggle" 
                  id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                  Situación Laboral
                </a>
                <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                  <li><a class="dropdown-item cursor_pointer" @click="addEmploymentSituation">Añadir Situación Laboral de Privados de libertad</a></li>
                  <li><a class="dropdown-item cursor_pointer" @click="listEmploymentSituation">Lista de PPL con Situación Laboral registrada </a></li>
                  <!-- <li><a class="dropdown-item" href="#">Something else here</a></li> -->
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      <!-- agregar contacto de privado de libertad-->
      <div v-if="isAddingPplContact">
          <!--búsqueda de persona privada de libertad -->
            <div class="row my-5">
              <div class="col-md-4 mt-5">
                <label class="form-label"
                  >Búsqueda PPL:
                  <i
                    class="fas fa-info-circle"
                    title="La búsqueda deberá realizarse por el Nombre completo o Número de documento de identidad"
                  >
                  </i>
                </label>
                <input
                  type="text"
                  class="form-control fuente"
                  style="text-transform: uppercase"
                  id="dato"
                  v-model.trim="dato_busqueda_ppl"
                  @keyup.enter="searchPpl(dato_busqueda_ppl)"
                  @input="checkFieldEmpty($event, dato_busqueda_ppl, 'dato_ppl')"
                />
              </div>
              <div class="col-md-3 col-sm-12 mt-7">
                <button
                  type="button"
                  style="margin: 5px"
                  class="btn px-3"
                  :disabled="!dato_busqueda_ppl"
                  @click="searchPpl(dato_busqueda_ppl)"
                >
                  <i
                    title="Realizar búsqueda de Ppl"
                    style="font-size: 1.5em; color: Dodgerblue"
                    class="fas fa-magnifying-glass"
                  ></i>
                </button>
                <button
                  type="button"
                  style="margin: 10px"
                  class="btn px-3"
                  @click="
                    (dato_busqueda_ppl = ''),
                      (resultados_ppls = []),
                      (relativesList =[]),
                      (stateContactPpl.formData.id_persona = null)
                  "
                >
                  <i
                    title="Vaciar campo"
                    style="font-size: 1.5em; color: red"
                    class="fas fa-trash"
                  ></i>
                </button>
              </div>
            </div>
            <!-- lista de ppls -->
            <div class="row table-responsive">
              <table class="table">
                <caption v-if="resultados_ppls.length > 0" style="caption-side: top">
                  {{
                    resultados_ppls.length === 1 ? "Existe" : "Existen"
                  }}
                  {{
                    resultados_ppls.length
                  }}
                  {{
                    resultados_ppls.length === 1
                      ? "coincidencia"
                      : " posibles coincidencias"
                  }}
                </caption>
                <thead>
                  <tr >
                    <th>NOMBRE PPL</th>
                    <th>N° DOCUMENTO</th>
                    <th>RECINTO PENITENCIARIO</th>
                    <th>DELITO</th>
                    <th>SELECCIONAR</th>
                  </tr>
                </thead>
                <tbody>
                  <td v-if="resultados_ppls.length == 0 && !isLoading" colspan="8">
                    Sin datos que mostrar
                  </td>
                  <td v-else-if="resultados_ppls.length == 0 && isLoading" colspan="8">
                    Cargando...
                  </td>
                  <tr v-else v-for="dato in resultados_ppls" :key="dato.id_persona">
                    <td data-column="NOMBRE PPL">{{ dato.nombre_completo }}</td>
                    <td data-column="N° DOCUMENTO">{{ dato.nro_doc }}</td>
                    <td data-column="RECINTO">
                      {{ dato.nombre_recinto_penitenciario }}
                    </td>
                    <td data-column="DELITO">{{ dato.descripcion_delito }}</td>
                    <td data-column="SELECCIONAR">
                      <input
                        type="radio"
                        :value="dato.id_persona"
                        :id="dato.id_persona"
                        v-model="stateContactPpl.formData.id_persona"
                        @change="getRelativesList(dato.id_persona)"
                      />
                    </td>
                  </tr>
                </tbody>
                <!-- <span class="text-danger" v-if="!stateContactPpl.formData.id_persona">
                  Seleccione una Persona Privada de Libertad
                </span> -->
              </table>
            </div>
            <hr class="my-5">
            <div>
            <h4>Lista de Familiares Registrados</h4>
            <button 
              class="btn btn-danger my-5" 
              :disabled="!stateContactPpl.formData.id_persona"
              @click="openCloseFormAddContact">
              <i :class="!isAddingContact?'fa fa-plus':'fa fa-window-close'"></i>
              {{!isAddingContact?'Agregar':'Cerrar'}}
            </button>
              <table class="table">
                <caption v-if="relativesList.length > 0" style="caption-side: top">
                  {{
                    relativesList.length === 1 ? "Existe" : "Existen"
                  }}
                  {{
                    relativesList.length
                  }}
                  {{
                    relativesList.length === 1
                      ? "registro"
                      : "registros"
                  }}
                </caption>
                <thead>
                  <tr >
                    <th>NOMBRE FAMILIAR</th>
                    <th>PARENTESCO</th>
                    <th>N° TELÉFONO</th>
                    <th>ACCIONES</th>
                  </tr>
                </thead>
                <tbody>
                  <td v-if="relativesList.length == 0 && !isLoading" colspan="8">
                    Sin datos que mostrar
                  </td>
                  <td v-else-if="relativesList.length == 0 && isLoading" colspan="8">
                    Cargando...
                  </td>
                  <tr v-else v-for="familiar in relativesList" :key="familiar.id_persona">
                    <td data-column="NOMBRE FAMILIAR">{{ familiar.nombre_completo }}</td>
                    <td data-column="PARENTESCO">{{ familiar.nombre_parentesco }}</td>
                    <td data-column="TELÉFONO">{{ familiar.numero_telefono }}</td>
                    <td data-label="Acciones">
                      <div class="icon-container">
                      <i 
                        class="fa fa-edit fa-2x" 
                        style="color:skyblue" 
                        title="editar"
                        @click="fillEditPplContact(familiar)"
                        ></i>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-if="isAddingContact || isEdditingContact" class="row">
            <!-- nombre completo -->
              <div class="col-md-6 p-2">
                <label for="" required>Nombre completo:</label>
                <input 
                  type="text"
                  class="form-control"
                  id="nombre_completo"
                  v-uppercase
                  v-model.trim="stateContactPpl.formData.nombre_completo"
                >
              </div>
              <!-- parentesco -->
              <div class="col-md-6 p-2">
                <label for="" required>Parentesco:</label>
                <select 
                  class="form-select"
                  v-model.trim="stateContactPpl.formData.id_parentesco"
                  id="sub_asistencia"
                >
                  <option selected disabled>Seleccione una opción</option>
                  <option 
                    v-for="dato in relationshipList" 
                    :key="dato.id_parentesco" 
                    :value="dato.id_parentesco"
                  >
                    {{ dato.nombre_parentesco }}
                  </option>
                </select>
              </div>
              <!-- ASISTENCIA -->
              <div class="col-md-6 p-2">
                <label for="" required>Número de Contacto:</label>
                <input 
                  type="text"
                  class="form-control"
                  v-uppercase
                  :disabled="isAddingOtherAttendance"
                  v-model.trim="stateContactPpl.formData.numero_telefono"
                >
              </div>
              <p class="p-2" align="right">
                <button
                  class="btn btn-danger"
                  @click="clearFormContactPpl()"
                >
                  Limpiar
                </button>&nbsp;
                <button
                  v-if="!isLoading"
                  class="btn btn-success"
                  :disabled="!validateRegisterPplContactForm"
                  @click="isAddingContact?registerPplContact():editPplContact()"
                >
                  {{isAddingContact?'Registrar':'Editar'}} Contacto Familiar
                </button>
                <button
                    v-else
                    class="btn btn-primary"
                    disabled
                  >
                    Por favor espere ...
                </button>
              </p>
            </div>
      </div>
      <!-- agregar situación laboral-->
      <div v-if="isAddingEmploymentSituation">
        <!--búsqueda de persona privada de libertad -->
            <div class="row my-5">
              <div class="col-md-4 mt-5">
                <label class="form-label"
                  >Búsqueda PPL:
                  <i
                    class="fas fa-info-circle"
                    title="La búsqueda deberá realizarse por el Nombre completo o Número de documento de identidad"
                  >
                  </i>
                </label>
                <input
                  type="text"
                  class="form-control fuente"
                  style="text-transform: uppercase"
                  id="dato"
                  v-model.trim="dato_busqueda_ppl"
                  @keyup.enter="searchPpl(dato_busqueda_ppl)"
                  @input="checkFieldEmpty($event, dato_busqueda_ppl, 'dato_ppl')"
                />
              </div>
              <div class="col-md-3 col-sm-12 mt-7">
                <button
                  type="button"
                  style="margin: 5px"
                  class="btn px-3"
                  :disabled="!dato_busqueda_ppl"
                  @click="searchPpl(dato_busqueda_ppl)"
                >
                  <i
                    title="Realizar búsqueda de Ppl"
                    style="font-size: 1.5em; color: Dodgerblue"
                    class="fas fa-magnifying-glass"
                  ></i>
                </button>
                <button
                  type="button"
                  style="margin: 10px"
                  class="btn px-3"
                  @click="
                    (dato_busqueda_ppl = ''),
                      (resultados_ppls = []),
                      (relativesList =[]),
                      (stateContactPpl.formData.id_persona = null)
                  "
                >
                  <i
                    title="Vaciar campo"
                    style="font-size: 1.5em; color: red"
                    class="fas fa-trash"
                  ></i>
                </button>
              </div>
            </div>
            <!-- lista de ppls -->
            <div class="row table-responsive">
              <table class="table">
                <caption v-if="resultados_ppls.length > 0" style="caption-side: top">
                  {{ resultados_ppls.length === 1 ? `Existe ${resultados_ppls.length} coincidencia` : `Existen ${resultados_ppls.length} posibles coincidencias`}}
                </caption>
                <thead>
                  <tr >
                    <th>NOMBRE PPL</th>
                    <th>N° DOCUMENTO</th>
                    <th>RECINTO PENITENCIARIO</th>
                    <th>DELITO</th>
                    <th>SELECCIONAR</th>
                  </tr>
                </thead>
                <tbody>
                  <td v-if="resultados_ppls.length == 0 && !isLoading" colspan="8">
                    Sin datos que mostrar
                  </td>
                  <td v-else-if="resultados_ppls.length == 0 && isLoading" colspan="8">
                    Cargando...
                  </td>
                  <tr v-else v-for="dato in resultados_ppls" :key="dato.id_persona">
                    <td data-column="NOMBRE PPL">{{ dato.nombre_completo }}</td>
                    <td data-column="N° DOCUMENTO">{{ dato.nro_doc }}</td>
                    <td data-column="RECINTO">
                      {{ dato.nombre_recinto_penitenciario }}
                    </td>
                    <td data-column="DELITO">{{ dato.descripcion_delito }}</td>
                    <td data-column="SELECCIONAR">
                      <input
                        type="radio"
                        :value="dato.id_persona"
                        :id="dato.id_persona"
                        v-model="stateContactPpl.formData.id_persona"
                        @change="getRelativesList(dato.id_persona)"
                      />
                    </td>
                  </tr>
                </tbody>
                <!-- <span class="text-danger" v-if="!stateContactPpl.formData.id_persona">
                  Seleccione una Persona Privada de Libertad
                </span> -->
              </table>
            </div>
            <div class="row my-5 d-flex justify-content-center">
             <div class="col-md-8 p-2">
               <label for="" required>Último trabajo:</label>
               <input 
                 type="text"
                 class="form-control"
                 v-uppercase
                 v-model.trim="stateEmploymentBeforeConfinement[0].ultimo_trabajo"
               >
              </div>
              <div class="col-md-8 p-2">
               <label for="" required>Edad que empezó a trabajar:</label>
               <input 
                 type="number"
                 class="form-control"
                 v-uppercase
                 v-model.trim="stateEmploymentBeforeConfinement[0].edad_primer_trabajo"
               >
              </div>
              <div class="col-md-8 p-2">
               <label for="" required>Razón por la que empezó a trabajar:</label>
               <textarea 
                 type="text"
                 class="form-control"
                 v-uppercase
                 v-model.trim="stateEmploymentBeforeConfinement[0].razon_primer_trabajo"
               />               
              </div>
              <div class="row m-5 d-flex justify-content-center">
                <div class="col-md-7 p-2">
                <label for="" required>Tipos de trabajo que realizó:</label>
                <input 
                  type="text"
                  class="form-control"
                  v-uppercase
                  v-model.trim="employement.nombre_trabajo"
                  @keyup.enter="addEmployementToArray"
                >
                </div>
                <div class="col-md-1 py-8">
                  <button 
                    class="btn btn-primary"  
                    :disabled="!employement.nombre_trabajo" 
                    @click="addEmployementToArray"                    
                    > Añadir</button>
                </div>
                <div class="col-md-7">
                  <div class="row table-responsive">
                    <table class="table">
                      <caption v-if="resultados_ppls.length > 0" style="caption-side: top">
                        {{ resultados_ppls.length === 1 ? `Existe ${resultados_ppls.length} coincidencia` : `Existen ${resultados_ppls.length} posibles coincidencias`}}
                      </caption>
                      <thead>
                        <tr >
                          <th>N°</th>
                          <th>NOMBRE TRABAJO</th>
                          <th>ACCIONES</th>
                        </tr>
                      </thead>
                      <tbody>
                        <td v-if="stateEmploymentBeforeConfinement[0].tipos_trabajos_realizados.length == 0 && !isLoading" colspan="3">
                          Sin datos que mostrar
                        </td>
                        <td v-else-if="stateEmploymentBeforeConfinement[0].tipos_trabajos_realizados.length == 0 && isLoading" colspan="3">
                          Cargando...
                        </td>
                        <tr v-else v-for="(empleo,index) in stateEmploymentBeforeConfinement[0].tipos_trabajos_realizados" :key="index">
                          <td data-column="N°">{{index + 1}}</td>
                          <td data-column="NOMBRE TRABAJO">{{ empleo.nombre_trabajo }}</td>
                          <td data-label="Acciones">
                            <div class="icon-container">
                            <i class="fa fa-edit fa-2x" style="color:skyblue" title="editar" @click="editEmployement(empleo, index)"></i>&nbsp;
                            </div>
                            <div class="icon-container">
                            <i class="fa fa-trash fa-2x" style="color:red" title="eliminar" @click="deleteEmployement(index)"></i>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>  
              </div>
              </div>              
            </div>
      </div>
    </div>
  </div>
  <div  v-if="isChart" class="row">
     <div class="card-body col-6">
      <!--begin::Chart-->
      <apexchart
        
        type="area"
        :options="chartOptions"
        :series="series"
      ></apexchart>
    </div>
    <div class="card-body col-6">
      <!--begin::Chart-->
      <apexchart type="pie" :options="chartOptionspie" :series="seriespie"></apexchart>
    </div>
     </div>
  <loading
      v-model:active="isLoading"
      :can-cancel="false"
      :is-full-page="true"
      loader="bars"
      :height="100"
      :width="100"
  ></loading>
  </template>
  <script>
import {
  computed,
  defineComponent,
  onMounted,
  onUnmounted,
  reactive,
  ref,
  inject,
} from "vue";
import Loading from "vue-loading-overlay";
import user from "@/user/composables/useUser";
import useAuth from "@/auth/composables/useAuth";
import filiation from "@/filiation/composables/useFiliation";
import visits from "@/visits/composables/useVisits";
import modSocial from "@/mod_social/composables/useModSocial";
import es from "apexcharts/dist/locales/es.json"
import Swal from "sweetalert2/dist/sweetalert2.min.js";
export default defineComponent({
  name: "registerSocialForm",
   components: {
        Loading,
        },
  props: {
    nombre_ruta: String,
  },
  setup(props, context){
    const dato_busqueda_ppl =ref();
    const resultados_ppls = ref([]);
    const isLoading = ref(false);
    const departmentsList = ref([]);
    const nameNavbar = computed(() => props.nombre_ruta);
    const isChart = ref(true);
    const isAddingPsychologicattendance = ref(false);
    const isListTeachers = ref(false);
    const isAddingPplContact = ref(false);
    const isAddingEmploymentSituation = ref(false);
    const isListPplContact = ref(false);
    const isCourse = ref(false);
    const isInstitution = ref(false); 
    const isEditingInstitution = ref(false);
    const isEditingPpl = ref(false);
    const isEditingCourse = ref(false);
    const isAddingOtherAttendance =ref(false);
    const dato_busqueda = ref(null);
    const asistenciaPrincipalList =ref([]);
    const subAsistenciaList =ref([]);
    const asistenciaList = ref([]);
    const institutionsList =ref([]);
    const coursesList = ref([]);
    const prisionsList =ref([]);
    const attendanceList =ref([]);
    const pplAttendanceList =ref([]);
    const fecha_actual = computed(()=>{
      let today = new Date();
      let dd = today.getDate();
      let mm = today.getMonth()+1; //January is 0!
      let yyyy = today.getFullYear();
      if(dd<10){
              dd='0'+dd
      } 
       if(mm<10){
             mm='0'+mm
       } 

          return today = yyyy+'-'+mm+'-'+dd; 
    })

    const Toast = Swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
    });
    let chartOptions = ref({
      chart: {
        id: "vuechart",
        locales: [es],
        defaultLocale: "es",
        toolbar: {
          show: true,
          offsetX: 0,
          offsetY: 0,
          tools: {
            download: true,
            selection: false,
            zoom: true,
            zoomin: true,
            zoomout: true,
            pan: false,
            reset: true | '<img src="/static/icons/reset.png" width="20">',
            customIcons: [],
          },
          export: {
            csv: {
              filename: "Sirep_report",
              columnDelimiter: ":",
              headerCategory: "category",
              headerValue: "value",
              dateFormatter(timestamp) {
                return new Date(timestamp).toDateString();
              },
            },
            svg: {
              filename: "Sirep_report",
            },
            png: {
              filename: "Sirep_report",
            },
          },
          autoSelected: "zoom",
        },
      },
      xaxis: {
        categories: [],
        labels: {
          show: true,
          rotate: -800,
          rotateAlways: true,
          hideOverlappingLabels: false,
          showDuplicates: false,
          trim: true,
          minHeight: 200,
          maxHeight: 200,
          style: {
            colors: [],
            fontSize: "12px",
            fontFamily: "Helvetica, Arial, sans-serif",
            fontWeight: 200,
            cssClass: "apexcharts-xaxis-label",
          },
          offsetX: 0,
          offsetY: 0,
        },
      },
    });
    let series = ref([
      {
        name: "Personas privadas de libertad",
        data: [],
      },
    ]);
    let seriespie= ref([44, 55, 13, 43, 22]);
    const chartOptionspie= ref({
            chart: {
              width: 380,
              type: 'pie',
            }});
    
    const {
      // searchSegip,
      nameDepartments,
      // nameProvinces,
      // namePenitentiaries,
      // nameRoles,
      // createUser,
      // infoUser,
      // infoRolesUser,
      // infoPasswordUser,
      // updateUser,
      // sendMail,
    } = user();
    const {
      // rol,
      // nombre_recinto_penitenciario,
      departamento_centro_penitenciario,
      // departamento_supervisar,
       id_recinto,
    } = useAuth();
    const { valueToSearch } = visits();
    const {prisionNames, relationships} = filiation();
    const {
      getRelatives,
      saveContactPpl,
      saveEditedPplContact,


           saveAttendance, 
           getAsistencia,
           
           getPplAttendance,



    
           deleteInstitution,
           deleteCourse,

           
           getTeachers,
           deleteattendanceById,
           deleteattendanceCourseById,

           getStudents,
           editStudent,
           deletePplattendanceById
           
           } = modSocial();
    const searchPpl = async (value) => {Toast.fire({
            icon: "info",
            title: "No existen coincidencias con los datos ingresados",
          });
        isLoading.value = true;
        const { data } = await valueToSearch(value.toUpperCase());
        if (!data.ok) {
          Toast.fire({
            icon: "info",
            title: "No existen coincidencias con los datos ingresados",
          });
          isLoading.value = false;
        } else {
            Toast.fire({
              icon: "success",
              title: "La búsqueda retornó resultados!",
            });
          isLoading.value = false;
          resultados_ppls.value = data.respuesta;
        }
      };
// verificar si campos de busqueda estan vacios
    const checkFieldEmpty = (dato, type) => {
      if (dato === "" && type === "dato_ppl") {
        stateContactPpl.formData.id_persona = "";
        resultados_ppls.value = [];
      }
    };      
    const listPrisions = async () => {
      const { data } = await prisionNames();
      if (departamento_centro_penitenciario.value!=='NACIONAL') {
         const result = data.filter( value => value.id_recinto_penitenciario===id_recinto.value)
         prisionsList.value = result;        
      } else {
        prisionsList.value = data;
      }
    };
    const listNameDepartments = async () => {
      const { data } = await nameDepartments();
      departmentsList.value = data;
    };
    const capitalize = (word) => {
      if (!word) return ''; // Manejar el caso de una cadena vacía
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    };
    const relationshipList = ref([])
    const relativesList = ref([])
    const isAddingContact = ref(false)
    const isEdditingContact = ref(false)
    const relationship = async () => {
      const { data } = await relationships();
      relationshipList.value = data;
    };
    const getRelativesList = async (id_persona) =>{
      const { data } = await getRelatives(id_persona);
      relativesList.value = data;
      if (relativesList.value.length===0) {
        Toast.fire({
            icon: "info",
            title: "No existen datos de contactos familiares registrados",
          });
      }
    }
    const stateContactPpl = reactive({
      formData: {
        id_familiaresppl:0,
        id_persona:"",
        nombre_completo:"",
        id_parentesco:"",
        numero_telefono:"",
      },
    });
    const openCloseFormAddContact = () =>{
      isAddingContact.value = ! isAddingContact.value
      isEdditingContact.value = ! isEdditingContact.value
      stateContactPpl.formData.nombre_completo="",
      stateContactPpl.formData.id_parentesco="",
      stateContactPpl.formData.numero_telefono=""
    }
    const addPplContact = () =>{
      isAddingPplContact.value = !isAddingPplContact.value
      isAddingEmploymentSituation.value = false;
      if(isChart.value == true){
        isChart.value = false 
      }
      if (!isAddingPplContact.value) {
        isChart.value = true
      }
    }
    const clearFormContactPpl = () => {
        isAddingContact.value = ! isAddingContact.value
        stateContactPpl.formData.id_familiaresppl=0,
        stateContactPpl.formData.id_persona="",
        stateContactPpl.formData.nombre_completo="",
        stateContactPpl.formData.id_parentesco="",
        stateContactPpl.formData.numero_telefono=""
        relativesList.value=[]
        resultados_ppls.value=[]
        dato_busqueda_ppl.value=""
    }
    const validateRegisterPplContactForm = computed(()=>{
      if (!stateContactPpl.formData.id_persona || !stateContactPpl.formData.nombre_completo || !stateContactPpl.formData.id_parentesco) {
        return false
      }else{
        return true
      }
    })
    const registerPplContact = async() =>{
      if (!validateRegisterPplContactForm.value) {
        alert("Todos los campos deben estar completos para el registro")
      }else{
        try {
            isLoading.value=true;
            const { data } = await saveContactPpl(stateContactPpl.formData);
            if (data.ok) {
                Swal.fire({
                  title: "¡Realizado!",
                  text: `El contacto fue añadido correctamente`,
                  icon: "success",
                  buttonsStyling: false,
                  confirmButtonText: "Continuar",
                  customClass: {
                    confirmButton: "btn fw-bold btn-light-primary",
                  },
                });
                stateContactPpl.formData.nombre_completo="",
                stateContactPpl.formData.id_parentesco="",
                stateContactPpl.formData.numero_telefono=""
                await getRelativesList(stateContactPpl.formData.id_persona)
                
            }
        } catch (error) {   
          console.log(error);
          Swal.fire({
                  title: "¡Error!",
                  text: `El contacto no pudo ser añadido`,
                  icon: "error",
                  buttonsStyling: false,
                  confirmButtonText: "Continuar",
                  customClass: {
                    confirmButton: "btn fw-bold btn-light-primary",
                  },
                });       
        }finally{
          isLoading.value=false
        }
      }
    }
    const fillEditPplContact= async(familiar) =>{
      isAddingContact.value=false;
      isListPplContact.value=false;
      isEdditingContact.value = true;
      const selectElement = document.getElementById('nombre_completo');
      if (selectElement) {
        selectElement.focus();
      }
      stateContactPpl.formData.id_familiaresppl=familiar.id_familiaresppl,
      stateContactPpl.formData.id_persona=familiar.cod_persona,
      stateContactPpl.formData.nombre_completo=familiar.nombre_completo,
      stateContactPpl.formData.id_parentesco=familiar.cod_parentesco,
      stateContactPpl.formData.numero_telefono=familiar.numero_telefono

    }
    const editPplContact = async() =>{
      if (!validateRegisterPplContactForm.value) {
        alert("Todos los campos deben estar completos para el registro")
      }else{
        try {
            isLoading.value=true;
            const { data } = await saveEditedPplContact(stateContactPpl.formData);
            if (data.ok) {
                Swal.fire({
                  title: "¡Realizado!",
                  text: `La Edición fue realizada correctamente`,
                  icon: "success",
                  buttonsStyling: false,
                  confirmButtonText: "Continuar",
                  customClass: {
                    confirmButton: "btn fw-bold btn-light-primary",
                  },
                });
                stateContactPpl.formData.nombre_completo="",
                stateContactPpl.formData.id_parentesco="",
                stateContactPpl.formData.numero_telefono=""
                isAddingContact.value=false
                isEdditingContact.value=false
                await getRelativesList(stateContactPpl.formData.id_persona)
            }
        } catch (error) {   
          console.log(error);
          Swal.fire({
                  title: "¡Error!",
                  text: `El registro no pudo ser realizado`,
                  icon: "error",
                  buttonsStyling: false,
                  confirmButtonText: "Continuar",
                  customClass: {
                    confirmButton: "btn fw-bold btn-light-primary",
                  },
                });       
        }finally{
          isLoading.value=false
        }
      }
    }
    const addEmploymentSituation = () =>{
      isAddingEmploymentSituation.value = !isAddingEmploymentSituation.value
      isAddingPplContact.value = false;
      if(isChart.value == true){
        isChart.value = false 
      }
      if (!isAddingEmploymentSituation.value) {
        isChart.value = true
      }
    }
    const employement = reactive ({
        nombre_trabajo:"",
    })
    const stateEmploymentBeforeConfinement = reactive([{
        id_empleo_antes_reclusion:0,
        ultimo_trabajo:"",
        edad_primer_trabajo:"",
        razon_primer_trabajo:"",
        tipos_trabajos_realizados:[]
    }
    ]);
    const addEmployementToArray = () => {
      stateEmploymentBeforeConfinement[0].tipos_trabajos_realizados.push({ ...employement });
       employement.nombre_trabajo=''
    };
    const deleteEmployement = (index) => {
      stateEmploymentBeforeConfinement[0].tipos_trabajos_realizados.splice(index, 1);
     };
    const editEmployement = (value, index) => {
      for (let i in stateEmploymentBeforeConfinement[0].tipos_trabajos_realizados) {
        if (i == index) {
          employement.nombre_trabajo = stateEmploymentBeforeConfinement[0].tipos_trabajos_realizados[i].nombre_trabajo;
          break;
        }
      }
      deleteEmployement(index);
    };

























    const fillEditInstitution = (id) =>{
      isEditingInstitution.value = true;
      const selectElement = document.getElementById('area_formacion_institucion');
      if (selectElement) {
        selectElement.focus();; 
      }
      const result = institutionsList.value.filter((value)=> value.id_institucion === id)
        // stateInstitution.formData.id_institucion=result[0].id_institucion,
        // stateInstitution.formData.id_asistencia_primaria=result[0].cod_area_formacion,
        // stateInstitution.formData.institucion=result[0].nombre_institucion,
        // stateInstitution.formData.departamento=result[0].departamento
    }
    const deleteInstitutionById = async (institucion) =>{
      Swal.fire({
        title: `¿Está seguro de eliminar a ${institucion.nombre_institucion} del departamento de ${institucion.departamento}?`,
        text: "Esta acción no podrá ser revertida",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "¡Si, eliminar!",
        cancelButtonText: "¡No, retornar!",
        reverseButtons: true
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
              isLoading.value=true;
              const { data } = await deleteInstitution(institucion.id_institucion);
              if (data.ok) {
                  Swal.fire({
                    title: "¡Realizado!",
                    text: `La institución ${institucion.nombre_institucion} de ${institucion.departamento} fue eliminada satisfactoriamente`,
                    icon: "success",
                    buttonsStyling: false,
                    confirmButtonText: "Continuar",
                    customClass: {
                      confirmButton: "btn fw-bold btn-light-primary",
                    },
                  });
                  // router.push({name:"listDeprivedLibertybyPrisons"})
              }
          } catch (error) {   
            console.log(error);
            Swal.fire({
                    title: "¡Error!",
                    text: `La institución no pudo ser eliminada`,
                    icon: "error",
                    buttonsStyling: false,
                    confirmButtonText: "Continuar",
                    customClass: {
                      confirmButton: "btn fw-bold btn-light-primary",
                    },
                  });       
          }finally{
            isLoading.value=false
          }
        }
      });
    }
    
    const clearFormAttendanceForm = () => {
        employement.nombre_trabajo=""
    }
    const addAttendanceToArray = () => {
      stateEmploymentBeforeConfinement[0].asistencias.push({ ...employement });
       clearFormAttendanceForm();
    };
    const deleteattendance = (index) => {
      stateEmploymentBeforeConfinement[0].asistencias.splice(index, 1);
     };
    const editAttendance = (value, index) => {
      for (let i in stateEmploymentBeforeConfinement[0].asistencias) {
        if (i == index) {
          employement.nombre_trabajo = stateEmploymentBeforeConfinement[0].tipos_trabajos_realizados[i].nombre_trabajo;
          break;
        }
      }
      deleteattendance(index);
    };
    const validateregisterAttendanceForm = () =>{
      if(!stateEmploymentBeforeConfinement[0].asistencia_primaria || !stateEmploymentBeforeConfinement[0].sub_asistencia || stateEmploymentBeforeConfinement[0].asistencias.length==0){
        return {ok:false,message:"El nombre de la asistencia primaria y sub-asistencia a al menos una asistencia son requeridos" }
      }else{
      return{ok:true}
      }
    }
    const registerAttendance = async() => {
    const {ok, message} = validateregisterAttendanceForm()
      if(!ok){
        alert(`${message}`)
      }else{
        try {
            isLoading.value=true;
            const { data } = await saveAttendance(stateEmploymentBeforeConfinement[0]);
            if (data.ok) {
                Swal.fire({
                  title: "¡Realizado!",
                  text: `La asistencia fue añadida exitosamente`,
                  icon: "success",
                  buttonsStyling: false,
                  confirmButtonText: "Continuar",
                  customClass: {
                    confirmButton: "btn fw-bold btn-light-primary",
                  },
                });
                stateEmploymentBeforeConfinement[0].asistencia_primaria='';
                stateEmploymentBeforeConfinement[0].sub_asistencia='';
                stateEmploymentBeforeConfinement[0].asistencias=[];
            }
        } catch (error) {   
          console.log(error);
          Swal.fire({
                  title: "¡Error!",
                  text: `El registro no pudo ser realizado`,
                  icon: "error",
                  buttonsStyling: false,
                  confirmButtonText: "Continuar",
                  customClass: {
                    confirmButton: "btn fw-bold btn-light-primary",
                  },
                });       
        }finally{
          isLoading.value=false;
          isAddingOtherAttendance.value=false;
        }
      }
    }
    const getattendanceList = async () =>{
      const { data } = await getTeachers(id_recinto.value);
      attendanceList.value = data;
    }
    const addAttendance = async(profesor)=>{
      isAddingPsychologicattendance.value=true;
      isListTeachers.value=false;
      isAddingOtherAttendance.value=true;
      stateEmploymentBeforeConfinement[0].asistencia_primaria=profesor.asistencia_primaria;
      stateEmploymentBeforeConfinement[0].sub_asistencia=profesor.sub_asistencia;
    }
    const deletePrimaryAttendanceRegistered = async (profesor) =>{
      Swal.fire({
        title: `¿Está seguro de eliminar a ${profesor.nombre_completo} y todas sus asignaturas?`,
        text: "Esta acción no podrá ser revertida",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "¡Si, eliminar!",
        cancelButtonText: "¡No, retornar!",
        reverseButtons: true
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
              isLoading.value=true;
              const { data } = await deleteattendanceById(profesor.id_profesor);
              if (data.ok) {
                  Swal.fire({
                    title: "¡Realizado!",
                    text: `La eliminación fue realizada con éxito`,
                    icon: "success",
                    buttonsStyling: false,
                    confirmButtonText: "Continuar",
                    customClass: {
                      confirmButton: "btn fw-bold btn-light-primary",
                    },
                  });
                  getattendanceList()
                  // router.push({name:"listDeprivedLibertybyPrisons"})
              }
          } catch (error) {   
            console.log(error);
            Swal.fire({
                    title: "¡Error!",
                    text: `La institución no pudo ser eliminada`,
                    icon: "error",
                    buttonsStyling: false,
                    confirmButtonText: "Continuar",
                    customClass: {
                      confirmButton: "btn fw-bold btn-light-primary",
                    },
                  });       
          }finally{
            isLoading.value=false
          }
        }
      });
    }
    const deleteAttendanceRegistered = async (asignatura, profesor) =>{
      Swal.fire({
        title: `¿Está seguro de eliminar la asignatura ${asignatura.nombre_asignatura} del profesor ${profesor.nombre_completo}?`,
        text: "Esta acción no podrá ser revertida",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "¡Si, eliminar!",
        cancelButtonText: "¡No, retornar!",
        reverseButtons: true
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
              isLoading.value=true;
              const { data } = await deleteattendanceCourseById(asignatura.id_profesor_asignatura, asignatura.cod_profesor);
              if (data.ok) {
                  Swal.fire({
                    title: "¡Realizado!",
                    text: `La eliminación fue realizada con éxito`,
                    icon: "success",
                    buttonsStyling: false,
                    confirmButtonText: "Continuar",
                    customClass: {
                      confirmButton: "btn fw-bold btn-light-primary",
                    },
                  });
                  getattendanceList()
                  // router.push({name:"listDeprivedLibertybyPrisons"})
              }
          } catch (error) {   
            console.log(error);
            Swal.fire({
                    title: "¡Error!",
                    text: `La institución no pudo ser eliminada`,
                    icon: "error",
                    buttonsStyling: false,
                    confirmButtonText: "Continuar",
                    customClass: {
                      confirmButton: "btn fw-bold btn-light-primary",
                    },
                  });       
          }finally{
            isLoading.value=false
          }
        }
      });
    }



    







    

    
    
    const getPplAttendanceList = async () =>{
      const { data } = await getPplAttendance(id_recinto.value);
      // if (stateCourse.formData.id_recinto_penitenciario) {
      // attendanceList.value = data.filter(value =>{value.cod_recinto_penitenciario==id_recinto.value})
      // }
      pplAttendanceList.value = data;
    }
    
    
    const deletePplAttendance = async (ppl) =>{
        Swal.fire({
          title: `¿Está seguro de eliminar a ${ppl.nombre_completo}?`,
          text: "Esta acción no podrá ser revertida",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "¡Si, eliminar!",
          cancelButtonText: "¡No, retornar!",
          reverseButtons: true
        }).then(async (result) => {
          if (result.isConfirmed) {
            try {
                isLoading.value=true;
                const { data } = await deletePplattendanceById(ppl.id_estudiante_asignatura);
                if (data.ok) {
                    Swal.fire({
                      title: "¡Realizado!",
                      text: `La eliminación fue realizada con éxito`,
                      icon: "success",
                      buttonsStyling: false,
                      confirmButtonText: "Continuar",
                      customClass: {
                        confirmButton: "btn fw-bold btn-light-primary",
                      },
                    });
                    getPplAttendanceList()
                }
            } catch (error) {   
              console.log(error);
              Swal.fire({
                      title: "¡Error!",
                      text: `La institución no pudo ser eliminada`,
                      icon: "error",
                      buttonsStyling: false,
                      confirmButtonText: "Continuar",
                      customClass: {
                        confirmButton: "btn fw-bold btn-light-primary",
                      },
                    });       
            }finally{
              isLoading.value=false
            }
          }
        });
    }
    onMounted(() => {
        listNameDepartments();
        listPrisions();
        relationship();
        // setCurrentPageBreadcrumbs(`${title.value} de Restricción de Visitante`, ["Visitas"]);
      });
    return{
      fecha_actual,
      dato_busqueda_ppl,
      searchPpl,
      checkFieldEmpty,
      resultados_ppls,
      isLoading,
      capitalize,

      openCloseFormAddContact,
      getRelativesList, 
      relativesList,
      isAddingContact,
      isEdditingContact,
      relationshipList,

      employement,
      stateEmploymentBeforeConfinement,
      addEmployementToArray,
      deleteEmployement,
      editEmployement,



      departmentsList,
      prisionsList,
      attendanceList,
      isAddingOtherAttendance,

      subAsistenciaList,
      asistenciaList,

      

      asistenciaPrincipalList, 
      departamento_centro_penitenciario,
      id_recinto,
      institutionsList,
      fillEditInstitution,
      deleteInstitutionById,

      coursesList,
      

      nameNavbar,
      isAddingPsychologicattendance,
      // stateEmploymentBeforeConfinement,
      clearFormAttendanceForm,
      isListTeachers,
      addAttendanceToArray,
      editAttendance,
      deleteattendance,
      registerAttendance,
      addAttendance,
      deletePrimaryAttendanceRegistered,
      deleteAttendanceRegistered,


      isAddingPplContact,
      isAddingEmploymentSituation,
      stateContactPpl,
      addPplContact,
      addEmploymentSituation,
      clearFormContactPpl,
      isListPplContact,
      editPplContact,
      validateRegisterPplContactForm,
      pplAttendanceList,
      fillEditPplContact,
      registerPplContact,
      deletePplAttendance,



      dato_busqueda,

      isEditingPpl,

      isCourse,
      isEditingCourse,

      isInstitution,
      isEditingInstitution,




      isChart,   
      chartOptions, 
      series,
      chartOptionspie,
      seriespie,


    }
  },
  directives: {
    // transform input to uppercase with v-uppercase
    uppercase: {
      updated: function (el) {
        el.value = el.value.toUpperCase();
        el.dispatchEvent(new Event("input"));
      },
    },
  }
})
</script>
<style scoped>
table   {
  width: 100%;
  border-collapse: collapse;
}

.table td,
.table th {
  padding: 12px 15px;
  border: 1px solid #ddd;
  text-align: center;
  font-size: 13px;
}
.table th {
  background-color: #92c9e6;
  color: #ffffff;
}

.table tbody tr:nth-child(even) {
  background-color: #d1e8f5;
}
.icon-container {
  display: inline-block;
  padding-right: 5px;
  cursor: pointer;
}
.icon-container i {
  font-size: 24px; /* Tamaño original del icono */
  transition: transform 0.3s ease; /* Transición suave */
}

.icon-container i:hover {
  transform: scale(1.2); /* Aumentar el tamaño del icono al hacer hover */
}
@media (max-width: 500px) {
  .table thead {
    display: none;
  }

  .table,
  .table tbody,
  .table tr,
  .table td {
    display: block;
    width: 100%;
  }
  .table tr {
    margin-bottom: 15px;
  }
  .table td {
    padding-left: 50%;
    text-align: left;
    position: relative;
  }
  .table td::before {
    content: attr(data-label);
    position: absolute;
    left: 0;
    width: 50%;
    padding-left: 15px;
    font-size: 15px;
    font-weight: bold;
    text-align: left;
  }
}
.cursor_pointer {
  cursor: pointer;
}
</style>